import { config } from "_config";
import { authHeader, mappingQueryParams, handleResponse } from "_helpers";

export const reportsBehindOrdersService = {
  getBehindOrders,
  getBehindOrderRules,
  createBehindOrderRules,
  deleteBehindOrderRules,
};

function getBehindOrders(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${config.apiUrl1}/reports/get-behind-orders-report${mappingQueryParams(params)}`;

  return fetch(url, requestOptions).then(handleResponse);
}

function getBehindOrderRules(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${config.apiUrl1}/reports/behind-order-rules${mappingQueryParams(params)}`;

  return fetch(url, requestOptions).then(handleResponse);
}

function createBehindOrderRules({ body }) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  };

  let url = `${config.apiUrl1}/reports/behind-order-rules`;

  return fetch(url, requestOptions).then(handleResponse);
}

function deleteBehindOrderRules({ id }) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  let url = `${config.apiUrl1}/reports/behind-order-rules/${id}`;

  return fetch(url, requestOptions).then(handleResponse);
}
